(function() {
  'use strict';
  
  function moveCurrencyToBar() {
    if (window.innerWidth <= 768) {
      return;
    }

    const currencyPicker = document.querySelector('.pick_currency.mldesk');
    const announcementBar = document.querySelector('aside.announcement-bar');

    if (currencyPicker && announcementBar) {
      if (announcementBar.contains(currencyPicker)) {
        return;
      }
      
      announcementBar.style.position = 'relative';
      announcementBar.appendChild(currencyPicker);
      
      currencyPicker.removeAttribute('style');
    }
  }

  function ensureCorrectPosition() {
    const currencyPicker = document.querySelector('.pick_currency.mldesk');
    const announcementBar = document.querySelector('aside.announcement-bar');
    
    if (currencyPicker && announcementBar) {
      if (!announcementBar.contains(currencyPicker)) {
        moveCurrencyToBar();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      moveCurrencyToBar();
    }, 100);
    
    setTimeout(function() {
      moveCurrencyToBar();
    }, 500);
    
    setTimeout(function() {
      moveCurrencyToBar();
    }, 1000);
  });

  const domObserver = new MutationObserver(function(mutations) {
    ensureCorrectPosition();
  });

  setTimeout(function() {
    domObserver.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }, 500);

  let positionCheckInterval = setInterval(function() {
    ensureCorrectPosition();
  }, 500);

  setTimeout(function() {
    clearInterval(positionCheckInterval);
    domObserver.disconnect();
  }, 10000);

  let hasMovedMobilePicker = false;

  function movePickerToMobileDrawer() {
    if (window.innerWidth > 768 || hasMovedMobilePicker) {
      return;
    }

    setTimeout(function() {
      const currencyPicker = document.querySelector('.pick_currency.mldesk');
      const drawer = document.querySelector('.menu-drawer'); 
      const closeButton = document.querySelector('.menu-drawer .menu-drawer__close-button');
      const niceSelect = currencyPicker ? currencyPicker.querySelector('.nice-select') : null;

      if (currencyPicker && closeButton && niceSelect && drawer) {
        let drawerTopBar = drawer.querySelector('.menu-drawer__top-bar-wrapper');
        if (!drawerTopBar) {
          drawerTopBar = document.createElement('div');
          drawerTopBar.classList.add('menu-drawer__top-bar-wrapper');
          drawerTopBar.style.cssText = `
            display: flex; 
            justify-content: space-between; 
            align-items: center; 
            padding: 0 var(--padding-lg);
          `;
          drawer.prepend(drawerTopBar);
        }
        
        drawerTopBar.appendChild(closeButton);
        drawerTopBar.appendChild(currencyPicker);
        
        currencyPicker.removeAttribute('style');
        if (niceSelect) {
          niceSelect.removeAttribute('style');
        }
        
        hasMovedMobilePicker = true;
      }
    }, 100); 
  }

  document.addEventListener('DOMContentLoaded', function() {
    const menuOpenButton = document.querySelector('details#Details-menu-drawer-container summary.header__icon--menu');
    if (menuOpenButton) {
      menuOpenButton.addEventListener('click', movePickerToMobileDrawer);
    }
  });

  let currencySelectorResizeTimer; 
  window.addEventListener('resize', function() {
    clearTimeout(currencySelectorResizeTimer);
    currencySelectorResizeTimer = setTimeout(function() {
      if (window.innerWidth > 768) {
        moveCurrencyToBar();
        ensureCorrectPosition();

        const drawerTopBar = document.querySelector('.menu-drawer__top-bar-wrapper');
        if (drawerTopBar) {
          const closeButton = drawerTopBar.querySelector('.menu-drawer__close-button');
          const drawer = document.querySelector('.menu-drawer');
          
          if (closeButton && drawer) {
            drawer.prepend(closeButton);
          }
          
          drawerTopBar.remove();
        }

        hasMovedMobilePicker = false;
      } else {
        hasMovedMobilePicker = false;
        
        const isDrawerOpen = document.querySelector('details#Details-menu-drawer-container[open]');
        if (isDrawerOpen) {
          movePickerToMobileDrawer();
        }
      }
    }, 250); 
  });

})();